import clsx from 'clsx'
import {useMemo} from 'react'
import {Helmet} from 'react-helmet'
import {Redirect, Route, Switch} from 'react-router-dom'
import {
  CustomerPortalAuthBackground,
  CustomerPortalAuthBackgroundMobile,
} from '../../../../config/logos'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useBreakpoint} from '../../../components/hooks/useBreakpoint'
import FirstLoginPasswordResetForm from '../components/FirstLoginPasswordReset'
import {ForgotPassword} from '../components/forms/ForgotPassword'
import {Login} from '../components/Login'
// import {Login} from '../components/Login'
import {MyPassLogin} from '../components/MyPassLogin'
import {useCustomerAuth} from '../hooks/useCustomerAuth'

export const AuthPage = () => {
  const {down} = useBreakpoint()
  const auth = useCustomerAuth()

  const isMobile = useMemo(() => {
    return down('xs')
  }, [down])

  const image = useMemo(() => {
    if (isMobile) {
      return CustomerPortalAuthBackgroundMobile.src
    }
    return CustomerPortalAuthBackground.src
  }, [isMobile])

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom bgi-position-x-center bgi-repeat-x bgi-size-contain bgi-attachment-fixed'
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: 'cover',
      }}
    >
      <Helmet>
        <title>Yas Marina Circuit</title>
        <link rel='icon' href='/portal.ico' />
      </Helmet>

      <div className='d-flex flex-center flex-column flex-column-fluid p-0 min-h-100vh my-5 py-5'>
        <img
          alt='Logo'
          src={toAbsoluteUrl('/media/saas/admm-customer-portal.png')}
          className='img-fluid w-300px w-100 mb-8'
        />
        <div className='w-sm-500px w-300px opacity-75 rounded shadow-sm p-2 p-lg-4 mx-auto'>
          {auth?.isFirstLogin() && <Redirect to='/auth/password-reset' />}
          {auth && !auth.isFirstLogin() && <Redirect to='/' />}
          <Switch>
            <Route path='/auth/login/:hash'>
              {process.env.REACT_APP_WEBNTECH_LOGIN &&
              process.env.REACT_APP_WEBNTECH_LOGIN === 'TRUE' ? (
                <MyPassLogin />
              ) : (
                <Login />
              )}
            </Route>
            <Route path='/auth/login'>
              {process.env.REACT_APP_WEBNTECH_LOGIN &&
              process.env.REACT_APP_WEBNTECH_LOGIN === 'TRUE' ? (
                <MyPassLogin />
              ) : (
                <Login />
              )}
            </Route>

            <Route path='/auth/password-reset' component={FirstLoginPasswordResetForm} />
            <Route path='/auth/forgot-password'>
              <ForgotPassword />
            </Route>
            <Redirect from='/auth' exact={true} to='/auth/login' />
            <Redirect to='/auth/login' />
          </Switch>
        </div>
        <img
          alt='Logo'
          src={toAbsoluteUrl('/media/saas/partner-logos.png')}
          className={clsx('mt-7 img-fluid')}
          style={{
            width: isMobile ? '310px' : '520px',
          }}
        />

        {/* <img alt={PoweredBy.alt} src={PoweredBy.src} className='h-30px mt-10' />  */}
      </div>
    </div>
  )
}
